import type { ElitePrimeInsightCta } from '../../../../types/elitePrimeSummary.types'
import type { EliteInsightsCta } from '../../../../types/misc.types'
import { postCTA as postCta } from '../../../../utils/appBridge'

/** True when the API returned a CTA object — hide the advice card when false. */
export function hasAdviceCardCta<T extends object>(cta?: T | null): cta is T {
  return cta != null
}

export function postAdviceCardCta(cta: EliteInsightsCta | ElitePrimeInsightCta) {
  postCta(JSON.stringify(cta))
}
